/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AccountInvolvements { 
    social_group_id: string;
    /**
     * Verified accounts ids
     */
    participant_account_ids: Array<string>;
    /**
     * Pending invitations account ids
     */
    pending_invitation_account_ids: Array<string>;
    /**
     * Pending requests account ids
     */
    pending_request_account_ids: Array<string>;
}